import React from 'react';
import {
  Box, Grid, makeStyles, Typography,
} from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
import { maxWidth } from '../../config/config';

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: theme.palette.common.black,
    minHeight: 300,
  },
  wrapperContent: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  wrapperCols: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  inner: {
    padding: theme.spacing(2),
    maxWidth: maxWidth + theme.spacing(2),
  },
  footerTitle: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    color: theme.palette.grey[500],
  },
  footerLink: {
    textDecoration: 'none',
    fontWeight: 'bold',
    color: theme.palette.grey[500],
    transition: 'color .2s ease',
    '&:hover': {
      color: theme.palette.common.white,
    },
  },
  footerNavItem: {
    marginBottom: theme.spacing(1),
  },
  col: {
    paddingTop: theme.spacing(6),
    color: theme.palette.grey[600],
  },
}));

const Footer = () => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <div className={classes.footer}>
      <div className={classes.wrapperContent}>
        <Grid
          container
          spacing={2}
          justifyContent="center"
        >
          <Grid
            className={classes.inner}
            item
            xs={12}
          >
            <div className={classes.wrapperCols}>
              <Grid
                container
                spacing={2}
              >
                <Grid
                  className={classes.col}
                  item
                  xs={12}
                  md={4}
                >
                  <Box mb={3}>
                    <Typography className={classes.footerTitle} component="div">
                      <FormattedMessage id="Footer.physioExtraGroup" />
                    </Typography>
                    <Typography component="div">
                      <FormattedMessage id="Footer.administrativeOffices" />
                    </Typography>
                  </Box>

                  <Box mb={3}>
                    <Typography component="div">
                      <FormattedMessage id="Footer.officeAddress" />
                    </Typography>
                    <Typography component="div">
                      <FormattedMessage id="Footer.officeAddressLine2" />
                    </Typography>
                    <Typography component="div">
                      <a
                        href="mailto:informationsweb@physioextra.ca"
                        className={classes.footerLink}
                        target="_blank"
                        rel="noreferrer"
                      >
                        informationsweb@physioextra.ca
                      </a>
                    </Typography>
                  </Box>

                  <Box mb={3}>
                    <Typography>
                      <FormattedMessage id="Footer.phone" />
                      <a
                        href="tel:+18557439872"
                        className={classes.footerLink}
                      >
                        1-855-743-9872
                      </a>
                    </Typography>
                    <Typography>
                      <FormattedMessage id="Footer.fax" />
                      <a
                        href="tel:+15143831735"
                        className={classes.footerLink}
                      >
                        514-383-1735
                      </a>
                    </Typography>
                  </Box>
                </Grid>

                <Grid
                  className={classes.col}
                  item
                  xs={12}
                  md={2}
                >
                  <Typography
                    component="div"
                    className={classes.footerNavItem}
                  >
                    <a
                      className={classes.footerLink}
                      href={intl.formatMessage({ id: 'Footer.clinicsLink' })}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FormattedMessage id="Footer.clinics" />
                    </a>
                  </Typography>
                  <Typography
                    component="div"
                    className={classes.footerNavItem}
                  >
                    <a
                      className={classes.footerLink}
                      href={intl.formatMessage({ id: 'Footer.servicesLink' })}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FormattedMessage id="Footer.services" />
                    </a>
                  </Typography>
                  <Typography
                    component="div"
                    className={classes.footerNavItem}
                  >
                    <a
                      className={classes.footerLink}
                      href={intl.formatMessage({ id: 'Footer.teamLink' })}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FormattedMessage id="Footer.team" />
                    </a>
                  </Typography>
                </Grid>

                <Grid
                  className={classes.col}
                  item
                  xs={12}
                  md={2}
                >
                  <Typography
                    component="div"
                    className={classes.footerNavItem}
                  >
                    <a
                      className={classes.footerLink}
                      href={intl.formatMessage({ id: 'Footer.careersLink' })}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FormattedMessage id="Footer.careers" />
                    </a>
                  </Typography>
                  <Typography
                    component="div"
                    className={classes.footerNavItem}
                  >
                    <a
                      className={classes.footerLink}
                      href={intl.formatMessage({ id: 'Footer.blogLink' })}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FormattedMessage id="Footer.blog" />
                    </a>
                  </Typography>
                  <Typography
                    component="div"
                    className={classes.footerNavItem}
                  >
                    <a
                      className={classes.footerLink}
                      href={intl.formatMessage({ id: 'Footer.aboutLink' })}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FormattedMessage id="Footer.about" />
                    </a>
                  </Typography>
                  <Typography
                    component="div"
                    className={classes.footerNavItem}
                  >
                    <a
                      className={classes.footerLink}
                      href={intl.formatMessage({ id: 'Footer.contactLink' })}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FormattedMessage id="Footer.contact" />
                    </a>
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

Footer.propTypes = {};

export default Footer;
